import axiosInstance from '../utils/axios';

// axiosInstance (utils/axios) injeta o Bearer no interceptor. As actions antigas
// usavam `axios` cru sem header nenhum — por isso as rotas /v3/marketing ficaram
// sem verifyToken tanto tempo. Passar por aqui e o que viabiliza a autenticacao.
const V3 = '/v3/marketing';
const V1 = '/api/v1';

const campanhasService = {

    /** Listagem com progresso agregado por campanha + totais para os stat cards. */
    listar: async (clienteId, params = {}) => {
        const response = await axiosInstance.get(`${V3}/campanhas`, {
            params: { cliente_id: clienteId, ...params },
        });
        return response.data;
    },

    criar: async (data) => {
        const response = await axiosInstance.post(`${V3}/campanhas`, data, {
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
        });
        return response.data;
    },

    /** Destinatarios paginados + resumo agregado + dados da timeline. */
    listarJobs: async (campanhaId, params = {}) => {
        const response = await axiosInstance.get(`${V3}/campanhas/${campanhaId}/jobs`, { params });
        return response.data;
    },

    /**
     * Cancela um envio. Substitui o antigo DELETE: apagar o job encolhia o total
     * da campanha e fazia a barra de progresso andar para tras.
     */
    cancelarJob: async (jobId) => {
        const response = await axiosInstance.patch(`${V3}/jobs/${jobId}/cancelar`);
        return response.data;
    },

    // --- rotas v1 ainda sem equivalente v3 ---

    buscarPorId: async (campanhaId) => {
        const response = await axiosInstance.get(`${V1}/campanhas/${campanhaId}/id`);
        return response.data;
    },

    editar: async (campanhaId, data) => {
        const response = await axiosInstance.post(`${V1}/campanhas/${campanhaId}/editar`, data, {
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
        });
        return response.data;
    },

    descontinuar: async (campanhaId) => {
        const response = await axiosInstance.delete(`${V1}/campanhas/${campanhaId}/deletar`);
        return response.data;
    },

    estimativa: async (clienteId, payload) => {
        const response = await axiosInstance.post(`${V1}/${clienteId}/campanhas/estimativa`, payload);
        return response.data;
    },
};

export default campanhasService;
